module.exports = __webpack_public_path__ + "img/whastapp.1f25178b.png";